import React from "react"
export default (props)=>{
        return (<footer className="container mt-3" >
        <div className="row " style={{marginBottom:50}}>
           
          <div className="col-sm-12 text-center text-md-left col-md-3 mb-2">© 2022 Optum Inc. All rights reserved.</div>
   
  
          <div className="text-muted text-center col-sm-12 col-md-1 "><a href="https://healthsafeid.optum.com/content/pages/default/PrivacyPolicy?HTTP_LANGUAGE=EN" id="privacy_link" target="_blank">Privacy</a></div>
  
          <div className="text-muted mt-md-0  mt-2  text-center col-sm-12 col-md-1"><a href="https://healthsafeid.optum.com/content/pages/default/TermsOfUse?HTTP_LANGUAGE=EN" id="tos_link"  target="_blank">Terms</a></div>
  
          <div className="text-muted  mt-md-0 mt-2  text-center col-sm-12 col-md-1"><a href={"./accessibility.html?lang=en"} id="tos_link"  target="_blank">Accessibility</a></div>
  
         {false && <div className="text-muted  mt-md-0 mt-2  text-center col-sm-12 col-md-1" ><a 
            target="_blank"
            href="http://eepurl.com/dPSco1" 
            id="tos_link"  >Signup</a></div> }
  
             
  
  
          
  
          <div className="downArrow  col-sm-12 col-md-5 text-right" style={{textAlign:"right"}}>
  
            <a href="#" className="btn--back-to-top-container gototop" aria-hidden="true"           >
                <div className="btn--back-to-top-container__btn"></div>
                <div className="btn--back-to-top-container__text">Top</div>
            </a>
          </div>
        </div>
        
      </footer>
  );

    }
